// import { auditStatus } from 'json/new-to-old-audit'
export let integralRewardLabels = [
  {
    label: '积分发放流水号',
    value: 'number'
  },
  {
    label: '事业部归属',
    value: 'businessDepartmentName'
  },
  {
    label: '生命银行用户',
    value: 'grantUser.firstName'
  },
  {
    label: 'C端手机号',
    value: 'grantUser.mobile'
  },
  {
    label: '平台注册时间',
    value: 'grantUser.register_date'
  },
  {
    label: '积分',
    value: 'points'
  },
  {
    label: '发放时间',
    value: 'created_date'
  }
//   {
//     label: '状态',
//     value: 'audit_status'
//   }
]
export let awardStatusTabs = [
  {
    label: '全部列表',
    value: 'ALL'
  },
  {
    label: '待审核',
    value: 'WAITING_FOR_APPROVAL'
  },
  {
    label: '已完成',
    value: 'COMPLETED'
  },
  {
    label: '已驳回',
    value: 'REJECTED'
  }
]
export let filterLabels = [
  {
    label: '发放时间',
    type: 'time-slot',
    startName: 'createdStartTime', // 返回数据时，开始时间的字段名
    endName: 'createdEndTime', // 返回数据时，结束时间的字段名
    value: 'grantDate'
  },
  {
    label: '发放积分',
    type: 'number-slot',
    clearable: true,
    minName: 'pointsMin',
    maxName: 'pointsMax',
    value: 'grantMoney'
  }
]
